import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import {
	ResendOtpResponse,
	UpdatePasswordPayload,
	UpdateProfilePayload,
	UpdateProfileResponse,
	VerifyOtpPayload,
	VerifyOtpResponse,
} from '../models/profile';

export const updatePassword = async (data: UpdatePasswordPayload) => {
	try {
		const response = await axios.put('dashboard/profile/update-password', data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const updateProfileData = async (data: UpdateProfilePayload) => {
	try {
		const response = await axios.put<JsonResponse<UpdateProfileResponse>>('dashboard/profile/update-profile', data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const verifyOtp = async (data: VerifyOtpPayload) => {
	try {
		const response = await axios.post<JsonResponse<VerifyOtpResponse>>('dashboard/profile/verify-phone', data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const resendOtp = async () => {
	try {
		const response = await axios.post<JsonResponse<ResendOtpResponse>>('dashboard/profile/resend-phone-otp');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const cancelOtp = async () => {
	try {
		const response = await axios.post<JsonResponse<VerifyOtpResponse>>('dashboard/profile/cancel-phone-update');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
